import { takeEvery, call, put, select } from "redux-saga/effects";
import {
  ADD_SONGS_TO_PLAYLISTS,
  LOAD_PLAYLISTS,
  loading,
  loadPlaylists,
  updatePlaylist,
  putPlaylists,
  updatePlaylistItem,
} from "../../store/ContentPlaylists/actions";
import { showAlertError, showAlertInfo, showAlertSuccess } from "../../store/Alert/actions";
import axios from "axios";
import {
  putAssocPublicTracks,
  updatePublicPlaylistItem,
} from "../../store/PublicPlaylists/actions";
import { forEach } from "lodash";

export default function* () {
  yield takeEvery(ADD_SONGS_TO_PLAYLISTS, worker);
}

function* worker({ payload }) {
  //yield put(loading(true))
  // console.log({ payload });

  try {
    const added = yield call(fetchAdd, payload);
    if (added.error) {
      yield put(
        showAlertError({
          errors: [`Ошибка сервера при ${ADD_SONGS_TO_PLAYLISTS}.`, added],
          text: "Треки не были добавлены. Попробуйте повторить.",
        })
      );
    } else {
      const updated_playlists = yield call(fetchPlaylists, payload);
      let playlistSongs;


      const fetchedPlaylistSongs = yield call(fetchPlaylistSongs, payload);
      playlistSongs = fetchedPlaylistSongs.success.songs





      for (let fetchedPlaylist of updated_playlists.success) {
        // console.log(">>>>>>", { ...fetchedPlaylist });
        let totalsize2 = 0;
        if (fetchedPlaylist.totalsize) {
          let size = Math.floor(fetchedPlaylist.totalsize / 1024 / 1024);
          size = !size
            ? `${Math.floor(fetchedPlaylist.totalsize / 1024)} Kb`
            : `${size} Mb`;
          totalsize2 = size;
          if (playlistSongs) {
            fetchedPlaylist.songs = playlistSongs
          }

        }
        fetchedPlaylist.totalsize2 = totalsize2;
        // console.log(">>>>>>", { ...fetchedPlaylist });
        // let selectedPlaylist = allPlaylists.find(playlist => playlist.id === fetchedPlaylist.id)
        //   yield put(
        //     updatePlaylist({
        //       playlist: {
        //         ...selectedPlaylist,
        //         ...fetchedPlaylist,
        //         songs: newSongsList || selectedPlaylist.songs,
        //       },
        //     })
        //   );
        yield put(updatePublicPlaylistItem(fetchedPlaylist));
        yield put(updatePlaylist({ playlist: fetchedPlaylist }));
        const isMultipleTracks = payload.tracks_ids.length > 1;
        const isMultiplePlaylists = payload.playlists_ids.length > 1;
        let text;
        if (isMultipleTracks) {
          text = `Треки были добавлены в плейлист${isMultiplePlaylists ? 'ы' : ''}`;
        } else {
          text = `Трек был добавлен в плейлист${isMultiplePlaylists ? 'ы' : ''}`;
        }

        yield put(showAlertSuccess({ text }));
      }

      // yield put(loadPlaylists());
    }
  } catch (e) {
    yield put(
      showAlertError({
        errors: [`Ошибка сети при ${ADD_SONGS_TO_PLAYLISTS}.`, e],
        text: "Треки не были добавлены. Попробуйте повторить.",
      })
    );
  } finally {
    yield put(loading(false));
  }
}

function fetchAdd(addData) {
  let formData = new FormData();
  addData.tracks_ids.forEach((id) => {
    formData.append("tracks_ids[]", id);
  });

  const playlists_ids = addData.playlists_ids
    .map((el) => `playlists_ids[]=${el.id}`)
    .join("&");

  return axios({
    url: `/playlist/tracks/insert?${playlists_ids}`,
    method: "POST",
    data: formData,
  }).then((response) => response.data);
}

function fetchPlaylistSongs(data) {

  return axios
    // .get(`/playlist/get?id=${data.playlists_ids[0].id}&sort[turn]=DESC`)
    .get(`/playlist/get?id=${data.playlists_ids[0].id}`)
    .then((response) => response.data);
}

function fetchPlaylists(addData) {
  const playlists_ids = addData.playlists_ids
    .map((el) => `id[]=${el.id}`)
    .join("&");

  return axios
    .get(`/playlist/select?${playlists_ids}`)
    .then((response) => response.data);
}
